const {
  keysSortedByValueAscending
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../../lib/evaluateSource');

/**
  * @function evaluate - evaluate benhurPercentCompleteBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const combined = (await evaluateSource(source.combined, content, parentContentPath, transientContext, nativeFunctions)) || {};
  const result = {};
  const laborKeys = keysSortedByValueAscending(combined);
  for (let laborIndex = 0; laborIndex < laborKeys.length; laborIndex += 1) {
    const laborKey = laborKeys[laborIndex];
    const {
      title: laborTitle,
      _created: laborCreated,
      children
    } = combined[laborKey];
    const activityKeys = keysSortedByValueAscending(children);
    for (let activityIndex = 0; activityIndex < activityKeys.length; activityIndex += 1) {
      const activityKey = activityKeys[activityIndex];
      const {
        title: activityTitle,
        _created: activityCreated,
        unitsTypes
      } = children[activityKey];
      result[`${laborKey}_${activityKey}`] = {
        _created: laborIndex * 1000 + activityIndex,
        laborActivity: {
          [laborKey]: {
            title: laborTitle,
            _created: laborCreated,
            children: {
              [activityKey]: {
                title: activityTitle,
                _created: activityCreated,
                unitsTypes
              }
            }
          }
        }
      };
    }
  }
  return result;
};
module.exports = {
  evaluate
};